import React, { type ReactElement, useEffect } from 'react'
import { Container } from 'react-bootstrap'
import MaPanel from '../../common/components/MaPanel'
import useSupplier from '../hooks/useSuppliers'
import loaderStyles from '../../common/assets/scss/LoadingSpinner.module.scss'
import LoadingSpinner from '../../common/components/LoadingSpinner'
import { getLocation } from '../../common/utils/location'

function NewSupplier (): ReactElement {
  const { create } = useSupplier()

  useEffect(() => {
    let isMounted = true

    create()
      .then(result => {
        if (!isMounted) return
        const supplierId = result?.id
        if (supplierId) {
          getLocation().assign(`/suppliers/${supplierId}#basicDetails`)
        }
      })
      .catch(() => {

      })

    return () => {
      isMounted = false
    }
  }, [create])

  return (
    <Container fluid="auto" className="ma-page">
      <MaPanel>
        <MaPanel.Body>
          <div className="flex items-center justify-center h-full">
            <div className={loaderStyles.spinner}>
              <LoadingSpinner />
            </div>
          </div>
        </MaPanel.Body>
      </MaPanel>
    </Container>
  )
}

export default NewSupplier
